export type DocsContentBlock =
  | { type: 'html'; content: string }
  | { type: 'mermaid'; chart: string }

function isMermaidPre(node: Node): node is HTMLElement {
  return node instanceof HTMLElement && node.matches('pre.mermaid')
}

function getMermaidChart(pre: HTMLElement): string {
  return (pre.querySelector('code')?.textContent ?? pre.textContent ?? '').trim()
}

export function splitDocsHtml(sanitizedHtml: string): DocsContentBlock[] {
  if (!sanitizedHtml.trim()) {
    return []
  }

  const doc = new DOMParser().parseFromString(
    `<div id="docs-split-root">${sanitizedHtml}</div>`,
    'text/html',
  )
  const root = doc.getElementById('docs-split-root')
  if (!root) {
    return [{ type: 'html', content: sanitizedHtml }]
  }

  const blocks: DocsContentBlock[] = []

  for (const child of Array.from(root.childNodes)) {
    if (isMermaidPre(child)) {
      const chart = getMermaidChart(child)
      if (chart) {
        blocks.push({ type: 'mermaid', chart })
        continue
      }
    }

    if (child instanceof HTMLElement) {
      blocks.push({ type: 'html', content: child.outerHTML })
    } else if (child.nodeType === Node.TEXT_NODE) {
      const text = child.textContent ?? ''
      if (text.trim()) {
        blocks.push({ type: 'html', content: text })
      }
    }
  }

  return blocks.length > 0 ? blocks : [{ type: 'html', content: sanitizedHtml }]
}
